import React, { useContext, useState } from "react";
import { Popover } from "antd";
import { truncate } from "../../library/text";
import SmallModal from "../../components/SmallModal/SmallModal";
import { AppContext } from "../../context";

function GuideCardContent({ product, context }) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const info = useContext(AppContext);

  const popoverContent = (
    <div>
      <p>{product.request}</p>
    </div>
  );

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <>
            <div className="card-body">
              {/* <div className="short-description">
                {product.gen_description
                  ? truncate(product.gen_description["pt-pt"], 100, true)
                  : ""}
              </div> */}
              <div className="short-description">
                <strong>{info.t("specialization")}: </strong>
                {product.gui_specializations?.length
                  ? product.gui_specializations.map((l) => info.t(l)).join(", ")
                  : ""}
              </div>
              <div className="short-description">
                <strong>{info.t("language")}: </strong>
                {product.gui_languages?.length
                  ? product.gui_languages.map((l) => info.t(l)).join(", ")
                  : ""}
              </div>
            </div>
          </>
        );
      case "cart":
      case "reservation":
      case "ticket":
      case "reservation-info":
      case "payment":
        return (
          <div>
            <div className="ahp-reservation-content">
              <div className="ahp-reservation-row">
                <div className="ahp-reservation-label">Preço</div>
                <div className="ahp-reservation-value">
                  {product.gen_price} €
                </div>
              </div>
              {context !== "reservation-info" && product.request && (
                <div className="ahp-reservation-notes">
                  <Popover
                    content={popoverContent}
                    title="Notas"
                    trigger="click"
                  >
                    <a role="button" tabindex="0">
                      Notas
                    </a>
                  </Popover>
                </div>
              )}
            </div>
          </div>
        );
        break;
      default:
        return <div></div>;
        break;
    }
  };

  return (
    <>
      {product.gen_price !== null &&
        product.gen_price !== 0 &&
        context != "ticket" &&
        context != "reservation-info" &&
        context != "payment" &&
        !(
          product.status == "not-available" || product.status == "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">{product.gen_price} €</div>
          </div>
        )}
      {selectComponent()}

      <SmallModal
        text="Preço total."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
      />
    </>
  );
}

export default GuideCardContent;
